import React from 'react';

// A simple, reusable success icon component
const CheckCircleIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" fill="currentColor" className="bi bi-check-circle-fill text-success" viewBox="0 0 16 16">
        <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
    </svg>
);

const Step6_Success = () => {
    const handleClose = () => {
        // This function attempts to close the current browser window or tab.
        // Note: Modern web browsers have security restrictions on window.close().
        // It will typically only work if the window was opened by a script (e.g., via window.open()).
        //window.close();
        //window.open("https://google.com", "_self");
        window.location.replace("https://google.com");
        // window.location.replace("https://smart-monitor.net/");
    };

    return (
        <div className="step-content text-center py-4 py-md-5">
            <CheckCircleIcon />
            <h2 className="fw-bold mt-4">Thank you for placing your Inspyre, powered by Acuma Health subscription order.</h2>
            <p className="mt-2 text-muted mx-auto" style={{ maxWidth: '800px', fontSize: "18px" }}>
                Please activate the Acuma Health app on your phone using the credentials provided in your Order Confirmation email.
            </p>
            {/* <p className="mt-2 text-muted mx-auto" style={{ maxWidth: '550px' }}>
                Please activate the Acuma Health app on your phone using the credentials in your Order Confirmation email.
            </p> */}
            {/* <div className="mt-4">
                <button onClick={handleClose} className="btn btn-primary">
                    Close Window
                </button>
            </div> */}
        </div>
    );
};

export default Step6_Success;
